import React, { useState } from 'react'
import { Stack, Typography } from '@sureco/design-system'
import { notification } from '@surecompanies/core_components'
import ContributionForm from './ContributionForm/ContributionForm'
import epsClient from 'enrollment-platform/api/eps.client'
import EmployeeResult from '../EmployeeResult'
import SelectionPane from '../SelectionPane'
import { relationshipMap } from './ContributionForm/relationship.enum'

export default function SearchableByExample({
  id,
  modelId,
  benchmarkSnapshotId,
  benchmarkSnapshotName,
  modelName,
}: {
  id: string
  modelId?: number
  benchmarkSnapshotId: number | null
  benchmarkSnapshotName: string
  modelName: string
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [contribution, setContribution] = useState<any>(null)
  const [selectedContribution, setSelectedContribution] = useState<any>(null)
  const getContribution = async (data: any) => {
    if (!modelId) {
      notification.error({
        message: 'Select a contribution model before previewing',
      })
      return
    }
    try {
      setIsLoading(true)
      setSelectedContribution(data)
      const qs = new URLSearchParams(data)
      if (benchmarkSnapshotId) {
        qs.append('benchmarkSnapshotId', String(benchmarkSnapshotId))
      }
      const response = await epsClient.get(
        `/customers/${id}/contributions/${modelId}/preview?${qs.toString()}`
      )
      setContribution(response.data)
      return response
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        maxHeight: '400px',
      }}
      space={10}
    >
      <SelectionPane title="By Example">
        <ContributionForm
          isLoading={isLoading}
          disabled={!modelId}
          onFormSubmit={(data: any) => getContribution(data)}
        />
      </SelectionPane>
      <Stack style={{ width: '100%' }} space={10}>
        <Typography color="#003146" size={16} bold>
          Monthly Employer Contribution
        </Typography>
        {selectedContribution ? (
          <Stack>
            <Typography color="#666" size={14} bold>
              Benchmark Snapshot:{' '}
              <Typography color="#666" size={12}>
                {benchmarkSnapshotName}
              </Typography>
            </Typography>

            <Typography color="#666" size={14} bold>
              Model:{' '}
              <Typography color="#666" size={12}>
                {`${modelId} - ${modelName}`}
              </Typography>
            </Typography>
            <EmployeeResult
              relationship={relationshipMap[selectedContribution?.relationship]}
              age={selectedContribution?.age}
              amount={contribution}
              isLoading={isLoading}
            />
          </Stack>
        ) : (
          <Typography color="#666" size={14}>
            Please select an example to preview
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
